import type { CSSProperties } from 'react'

export const kitTestThemeVars: CSSProperties & Record<string, string> = {
    '--background': '210 33% 98%',
    '--foreground': '220 20% 20%',
    '--card': '0 0% 100%',
    '--card-foreground': '220 20% 20%',
    '--popover': '0 0% 100%',
    '--popover-foreground': '220 20% 20%',
    '--primary': '217 100% 50%',
    '--primary-foreground': '0 0% 100%',
    '--secondary': '210 25% 96%',
    '--secondary-foreground': '220 20% 30%',
    '--muted': '210 20% 94%',
    '--muted-foreground': '220 10% 50%',
    '--accent': '210 30% 95%',
    '--accent-foreground': '217 100% 45%',
    '--destructive': '0 84% 60%',
    '--destructive-foreground': '0 0% 100%',
    '--border': '210 20% 90%',
    '--input': '210 20% 90%',
    '--ring': '217 100% 50%',
    '--radius': '1.25rem',
    '--shadow-soft': '0 4px 24px -4px hsl(220 20% 20% / 0.08)',
    '--shadow-card': '0 8px 32px -8px hsl(220 20% 20% / 0.1)',
}
